import { Seo, Breadcrumbs, breadcrumbSchema } from "@/components/Seo";
import { Reveal, SectionTag } from "@/components/Motion";

const PAGES = {
  privacy: {
    path: "/privacy-policy",
    title: "隐私政策 | TKShopMY",
    desc: "TKShopMY 如何收集、使用和保护你的个人资料，并说明马来西亚 2010 年个人资料保护法令（PDPA）下的相关权利。",
    h1: "隐私政策",
    updated: "2026 年 7 月 1 日",
    sections: [
      { h: "我们收集什么资料", p: "当你使用在线咨询时，我们会收集你发送的消息、你开始聊天的页面，以及浏览器类型、大概地区等技术资料。如果客服安排你转到 WhatsApp 继续沟通，你的电话号码会在你选择继续后，在 WhatsApp 内处理。我们也会收集网站分析数据（浏览页面、浏览深度、设备类型）；如果你从广告进入，会收集广告标识（例如 gclid）。" },
      { h: "为什么收集", p: "我们用这些资料来回复你的咨询、了解你的生意需求、推荐适合的服务、改善网站体验，以及衡量广告效果。" },
      { h: "我们如何使用", p: "聊天内容会被安全保存，让团队可以继续跟进你的对话。分析和广告数据只以汇总方式用来改善网站和广告。我们不会把你的个人资料卖给任何人。" },
      { h: "Cookies 与网站分析", p: "我们使用 cookies 和类似技术做网站分析（GA4）和广告效果衡量（Google Ads 转化追踪），帮助我们了解哪些页面有用、哪些广告带来真正的咨询。你可以在浏览器设置中关闭 cookies。" },
      { h: "广告追踪", p: "当你从 Google 广告进入网站时，gclid、gbraid 或 wbraid 等参数可能会保存在你的浏览器会话中，用来衡量广告表现。这些参数只和转化事件（例如开始在线咨询）关联，不会用来识别你的个人身份。" },
      { h: "WhatsApp 沟通", p: "本网站的咨询通过 WhatsApp 进行，对话内容用于团队跟进你的咨询。WhatsApp 上的沟通受 WhatsApp 自己的条款和隐私政策约束。" },
      { h: "资料保留期限", p: "聊天记录和咨询资料最长保留 24 个月，方便我们参考之前的对话，之后会删除或匿名化。你可以随时要求提前删除。" },
      { h: "你在马来西亚 PDPA 下的权利", p: "根据 2010 年个人资料保护法令，你有权查阅你的个人资料、要求更正，以及撤回处理同意。要行使这些权利，请通过本网站的 WhatsApp 咨询按钮或电邮联系我们。" },
      { h: "联系我们", p: "有任何隐私相关的问题或要求，请通过本网站的 WhatsApp 咨询，或电邮 hello@tkshopmy.com 联系我们。" },
    ],
  },
  terms: {
    path: "/terms",
    title: "服务条款 | TKShopMY",
    desc: "使用 TKShopMY 网站及我们的电商咨询与运营服务时所适用的条款。",
    h1: "服务条款",
    updated: "2026 年 7 月 1 日",
    sections: [
      { h: "我们的服务", p: "TKShopMY 提供电商咨询、TikTok Shop 开店指导、店铺管理、商品优化、内容方向及卖家支持服务。每次合作的具体范围会在工作开始前与客户书面确认。" },
      { h: "不保证结果", p: "我们不保证销量、订单数量、收入、店铺审核通过或任何特定的平台结果。TikTok Shop 的审核、流量分配和政策决定均由 TikTok Shop 独立作出。" },
      { h: "客户责任", p: "客户有责任确保所提供资料的准确性、所销售产品的合法性，以及遵守 TikTok Shop 的卖家政策和马来西亚法律。" },
      { h: "网站内容", p: "本网站内容只作一般资讯用途，不构成专业、法律或财务建议。平台相关资料可能随 TikTok Shop 政策更新而变化。" },
      { h: "知识产权", p: "本网站的所有内容、设计和品牌素材均属于 TKShopMY（另有注明除外）。TikTok 和 TikTok Shop 是其各自权利所有者的商标，本站仅用于描述我们服务所涉及的平台。" },
      { h: "责任限制", p: "在马来西亚法律允许的范围内，TKShopMY 不对使用本网站或我们服务所引起的间接或后果性损失负责，包括我们无法控制的平台政策变化。" },
      { h: "联系我们", p: "对这些条款有疑问：请使用本网站的 WhatsApp 咨询按钮，或电邮 hello@tkshopmy.com。" },
    ],
  },
  disclaimer: {
    path: "/disclaimer",
    title: "品牌声明 | TKShopMY",
    desc: "TKShopMY 是独立电商服务提供商，并非 TikTok 或 TikTok Shop 官方机构、官方代理、授权代表或关联公司。",
    h1: "品牌声明",
    updated: "2026 年 7 月 1 日",
    sections: [
      { h: "与 TikTok 的独立性", p: "TKShopMY 是独立电商服务提供商，并非 TikTok 或 TikTok Shop 官方机构、官方代理、授权代表或关联公司。TikTok、TikTok Shop 及相关商标均属于其各自权利所有者。" },
      { h: "平台决定", p: "TikTok Shop 的店铺审核、账号状态、流量分配、功能权限和政策执行，全部由 TikTok Shop 独立决定。TKShopMY 无法影响这些决定，也不以任何方式代表该平台。" },
      { h: "不作收入承诺", p: "本网站的任何内容都不构成对销量、订单、收入或商业结果的承诺。任何关于我们工作的描述都指我们所提供的服务本身，而非保证的商业成果。" },
      { h: "信息准确性", p: "我们会尽力保持平台相关资讯的更新，但 TikTok Shop 的规则、费用和功能经常变化。重要信息请以 TikTok Shop Seller Center 官方资料为准。" },
      { h: "联系我们", p: "对本声明有疑问：请使用本网站的 WhatsApp 咨询按钮，或电邮 hello@tkshopmy.com。" },
    ],
  },
};

export default function Legal({ page }) {
  const doc = PAGES[page];
  const crumbs = [{ name: "首页", path: "/" }, { name: doc.h1, path: doc.path }];
  return (
    <>
      <Seo title={doc.title} description={doc.desc} path={doc.path} schemas={[breadcrumbSchema(crumbs)]} />
      <section className="pt-28 md:pt-40 pb-20 md:pb-28" data-testid={`legal-${page}`}>
        <div className="mx-auto max-w-3xl px-5 md:px-8">
          <Breadcrumbs items={crumbs} />
          <Reveal>
            <SectionTag>法律信息</SectionTag>
            <h1 className="font-display text-4xl font-medium sm:text-5xl">{doc.h1}</h1>
            <p className="mt-3 text-sm text-ink/45">最后更新：{doc.updated}</p>
          </Reveal>
          <div className="mt-12 space-y-10">
            {doc.sections.map((s, i) => (
              <Reveal key={s.h} delay={Math.min(i * 0.04, 0.25)}>
                <h2 className="font-display text-xl font-semibold text-forest">{s.h}</h2>
                <p className="mt-3 text-sm leading-relaxed text-ink/70 md:text-base">{s.p}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
